import {ReactElement, ReactNode, useState} from "react";
import {ThemeProvider} from "@zendeskgarden/react-theming";
import {ViziblyTheme} from "../../../analyst/ViziblyZDGTheme";
import {DirectChartOfAccountsFileUpload} from "./DirectChartOfAccountsFileUpload";
import {FileUploadModalStates} from "./FileUploadModalStates";
import {ChooseCoA} from "./ChooseCoA";
import {Close, Modal} from "@zendeskgarden/react-modals";
import {CreateCustomCoaModal} from "./CreateCustomCoaModal";
import {ChooseExternalCoa} from "./ChooseExternalCoa";
import * as css from "./styles/AcquisitionPropertyAccountValuesModal.module.scss";

export interface IFileUploadModal {
    propertyId: string;
    jobCreated: (jobId: string, propertyId: string) => void;
    onModalClose: () => void;
}

export function AcquisitionPropertyAccountValuesModal(props: IFileUploadModal): ReactElement {
    const [state, setState] = useState<FileUploadModalStates>(FileUploadModalStates.CHOOSE_COA);

    let modalContent: ReactNode | undefined;
    switch(state) {
        case FileUploadModalStates.CHOOSE_COA:
            modalContent = <ChooseCoA setState={setState} {...props} />;
            break;
        case FileUploadModalStates.UPLOAD_DIRECT_COA_FILES:
            modalContent = <DirectChartOfAccountsFileUpload
                setState={setState}
                {...props}
            />;
            break;
        case FileUploadModalStates.CREATE_NEW_COA:
            modalContent = <CreateCustomCoaModal
                setState={setState}
                {...props}
            />;
            break;
        case FileUploadModalStates.CHOOSE_EXTERNAL_COA:
            modalContent = <ChooseExternalCoa
                setState={setState}
                {...props}
            />;
            break;
    }

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <Modal className={css.acquisitionPropertyAccountValuesModal} onClose={props.onModalClose}>
                {modalContent}
                <Close aria-label="Close modal" />
            </Modal>
        </ThemeProvider>
    );
}